// src/components/ExpenseListStyles.js
import { CATEGORY_COLORS, YEAR_COLORS } from './ColorConstants';

export const styles = {
  cardAnimation: {
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: (theme) => theme.shadows[8],
    },
  },
  fadeTransition: {
    animation: 'fadeIn 0.5s ease-in-out',
    '@keyframes fadeIn': {
      '0%': {
        opacity: 0,
        transform: 'translateY(20px)',
      },
      '100%': {
        opacity: 1,
        transform: 'translateY(0)',
      },
    },
  },
  transitionStyles: {
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  },
  // Se vuoi, puoi aggiungere anche stili che attingono a CATEGORY_COLORS, YEAR_COLORS, ecc.
};
